<template>
  <div class="ma-4 px-4">
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :items="feeRequestItems"
            fixed-header
            class="secondary row-height-50"
            hide-default-footer
          >
            <template #[`item.partner_id`]="{ item }">
              {{ getPartnerName(item.partner_id) }}
            </template>
            <template #[`item.program_id`]="{ item }">
              {{ getProgramName(item.program_id) }}
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="FeeRequestYearBatchHeaders"
            :search="search"
            :items="items"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                class="mr-2"
                color="accent"
                @click="navigateToFeeRequests(item)"
              >
                mdi-dots-horizontal
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  FeeRequestYearBatchHeaders,
  FeeRequestHeaders,
} from "@/constants/headers";

export default {
  components: {},
  data() {
    return {
      items: [],
      search: "",
      FeeRequestYearBatchHeaders,
      FeeRequestHeaders,
      headers: [],
      partners: [],
      programs: [],
      program_id: null,
      partner_id: null,
      feeRequestItems: [],
    };
  },
  created() {
    this.program_id = this.$route.query?.program_id;
    this.partner_id = this.$route.query?.partner_id;

    this.initialise();
  },
  methods: {
    async initialise() {
      await Promise.all([this.getPartners(), this.getPrograms()]);

      const partner = this.getPartnerName(this.partner_id);
      const program = this.getProgramName(this.program_id);
      if (!program || !partner) {
        this.$store.commit("showSnackbar", {
          message: "Program or Partner Missing",
          color: "error",
        });
        this.$router.go(-1);
        return;
      }
      this.$store.commit("setBreadcrumbs", [
        { text: "Term Invoice", to: { name: "Term Invoice" } },
        { text: `${partner} - ${program}` },
      ]);

      this.headers = this.FeeRequestHeaders.filter(
        (item) => item.value != "action"
      );
      this.getFeeRequestYearBatch();
      this.getFeeRequests();
    },
    async getPartners() {
      await this.$axios.get("/partners").then((res) => {
        this.partners = res.data.data;
      });
    },
    async getPrograms() {
      await this.$axios.get("/programs").then((res) => {
        this.programs = res.data.data;
      });
    },

    getPartnerName(id) {
      if (!id) return "";
      const partner = this.partners.find((p) => p.id == id);
      return partner ? partner.name : "";
    },

    getProgramName(id) {
      if (!id) return "";
      const program = this.programs.find((p) => p.id == id);
      return program
        ? program.degree.short_name +
            (program.specialization ? " - " + program.specialization : "")
        : "";
    },
    async getFeeRequestYearBatch() {
      await this.$axios
        .get("/get_term_fee_request_by_year_batch", {
          params: {
            partner_id: this.partner_id,
            program_id: this.program_id,
          },
        })
        .then((res) => {
          this.items = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    async getFeeRequests() {
      await this.$axios
        .get("/get_term_fee_request", {
          params: {
            partner_id: this.partner_id,
            program_id: this.program_id,
          },
        })
        .then((res) => {
          this.feeRequestItems = res.data.data;
        })
        .catch(async (error) => {
          this.$store.commit("showSnackbar", {
            message: error.response?.data?.message || "Failed to fetch",
            color: "error",
          });
        });
    },
    navigateToFeeRequests(item) {
      this.$router.push({
        path: "/term_fee_student",
        query: {
          partner_id: this.partner_id,
          program_id: this.program_id,
          year: item.year,
          batch: item.batch,
        },
      });
    },
    customFilter(value, search, item) {
      if (!search) return true;

      return JSON.stringify(item).toLowerCase().includes(search.toLowerCase());
    },
  },
};
</script>

<style></style>
